/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreeDsProviderEnum = exports.ThreeDsChallengeDisplaySizeEnum = exports.TaxType = exports.TaxIdFieldMode = exports.RecurringType = exports.PremiumAssetType = exports.PaymentRecurringType = exports.PaymentMethodConfigPaymentMethodType = exports.PaymentFiltersPaymentType = exports.OrderSessionPaymentMethodType = exports.MethodType = exports.InvoiceStatus = exports.IntervalUnit = exports.DirectDebitBrand = exports.ContractSwitchType = exports.CashType = exports.CardBrand = exports.BankTransferType = exports.AlternativePaymentMethodType = void 0;
var AlternativePaymentMethodType;
(function (AlternativePaymentMethodType) {
    AlternativePaymentMethodType["PAYPAL"] = "PAYPAL";
    AlternativePaymentMethodType["UNKNOWN"] = "UNKNOWN";
    AlternativePaymentMethodType["SEPA_OFFLINE"] = "SEPA_OFFLINE";
    AlternativePaymentMethodType["EXTERNAL_CREDIT_CARD"] = "EXTERNAL_CREDIT_CARD";
    AlternativePaymentMethodType["SOFORT"] = "SOFORT";
})(AlternativePaymentMethodType = exports.AlternativePaymentMethodType || (exports.AlternativePaymentMethodType = {}));
var BankTransferType;
(function (BankTransferType) {
    BankTransferType["SOFORT"] = "SOFORT";
    BankTransferType["UNKNOWN"] = "UNKNOWN";
})(BankTransferType = exports.BankTransferType || (exports.BankTransferType = {}));
var CardBrand;
(function (CardBrand) {
    CardBrand["UNKNOWN"] = "UNKNOWN";
    CardBrand["ELO"] = "ELO";
    CardBrand["AMEX"] = "AMEX";
    CardBrand["DISCOVER"] = "DISCOVER";
    CardBrand["DINERS"] = "DINERS";
    CardBrand["UNION_PAY"] = "UNION_PAY";
    CardBrand["JCB"] = "JCB";
    CardBrand["UNIONPAY"] = "UNIONPAY";
    CardBrand["VISA"] = "VISA";
    CardBrand["MASTERCARD"] = "MASTERCARD";
    CardBrand["CARTE_BLUE"] = "CARTE_BLUE";
})(CardBrand = exports.CardBrand || (exports.CardBrand = {}));
var CashType;
(function (CashType) {
    CashType["BOLETO"] = "BOLETO";
    CashType["UNKNOWN"] = "UNKNOWN";
})(CashType = exports.CashType || (exports.CashType = {}));
var ContractSwitchType;
(function (ContractSwitchType) {
    ContractSwitchType["FULL_AMOUNT_PERIOD"] = "FULL_AMOUNT_PERIOD";
    ContractSwitchType["DOWNGRADE"] = "DOWNGRADE";
    ContractSwitchType["UPGRADE"] = "UPGRADE";
    ContractSwitchType["UNKNOWN"] = "UNKNOWN";
    ContractSwitchType["REGULAR"] = "REGULAR";
})(ContractSwitchType = exports.ContractSwitchType || (exports.ContractSwitchType = {}));
var DirectDebitBrand;
(function (DirectDebitBrand) {
    DirectDebitBrand["SEPA"] = "SEPA";
    DirectDebitBrand["UNKNOWN"] = "UNKNOWN";
})(DirectDebitBrand = exports.DirectDebitBrand || (exports.DirectDebitBrand = {}));
var IntervalUnit;
(function (IntervalUnit) {
    IntervalUnit["MONTH"] = "MONTH";
    IntervalUnit["UNKNOWN"] = "UNKNOWN";
    IntervalUnit["DAY"] = "DAY";
    IntervalUnit["WEEK"] = "WEEK";
    IntervalUnit["YEAR"] = "YEAR";
})(IntervalUnit = exports.IntervalUnit || (exports.IntervalUnit = {}));
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["VOID"] = "VOID";
    InvoiceStatus["DECLINED"] = "DECLINED";
    InvoiceStatus["REFUNDED"] = "REFUNDED";
    InvoiceStatus["DRAFT"] = "DRAFT";
    InvoiceStatus["UNKNOWN"] = "UNKNOWN";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["PAYMENT_IN_PROGRESS"] = "PAYMENT_IN_PROGRESS";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
var MethodType;
(function (MethodType) {
    MethodType["GET"] = "GET";
    MethodType["POST"] = "POST";
    MethodType["UNKNOWN"] = "UNKNOWN";
})(MethodType = exports.MethodType || (exports.MethodType = {}));
var OrderSessionPaymentMethodType;
(function (OrderSessionPaymentMethodType) {
    OrderSessionPaymentMethodType["DIRECT_DEBIT"] = "DIRECT_DEBIT";
    OrderSessionPaymentMethodType["BANK_TRANSFER"] = "BANK_TRANSFER";
    OrderSessionPaymentMethodType["CASH"] = "CASH";
    OrderSessionPaymentMethodType["UNKNOWN"] = "UNKNOWN";
    OrderSessionPaymentMethodType["CARD"] = "CARD";
})(OrderSessionPaymentMethodType = exports.OrderSessionPaymentMethodType || (exports.OrderSessionPaymentMethodType = {}));
var PaymentFiltersPaymentType;
(function (PaymentFiltersPaymentType) {
    PaymentFiltersPaymentType["REAL_TIME"] = "REAL_TIME";
    PaymentFiltersPaymentType["RECURRING"] = "RECURRING";
    PaymentFiltersPaymentType["UNKNOWN"] = "UNKNOWN";
})(PaymentFiltersPaymentType = exports.PaymentFiltersPaymentType || (exports.PaymentFiltersPaymentType = {}));
var PaymentMethodConfigPaymentMethodType;
(function (PaymentMethodConfigPaymentMethodType) {
    PaymentMethodConfigPaymentMethodType["SEPA_OFFLINE"] = "SEPA_OFFLINE";
    PaymentMethodConfigPaymentMethodType["UNKNOWN"] = "UNKNOWN";
    PaymentMethodConfigPaymentMethodType["EXTERNAL_CREDIT_CARD"] = "EXTERNAL_CREDIT_CARD";
    PaymentMethodConfigPaymentMethodType["PAYPAL"] = "PAYPAL";
    PaymentMethodConfigPaymentMethodType["SOFORT"] = "SOFORT";
})(PaymentMethodConfigPaymentMethodType = exports.PaymentMethodConfigPaymentMethodType || (exports.PaymentMethodConfigPaymentMethodType = {}));
var PaymentRecurringType;
(function (PaymentRecurringType) {
    PaymentRecurringType["AUTO"] = "AUTO";
    PaymentRecurringType["HYBRID"] = "HYBRID";
    PaymentRecurringType["None"] = "None";
})(PaymentRecurringType = exports.PaymentRecurringType || (exports.PaymentRecurringType = {}));
var PremiumAssetType;
(function (PremiumAssetType) {
    PremiumAssetType["DOMAIN"] = "DOMAIN";
    PremiumAssetType["APP"] = "APP";
    PremiumAssetType["UNKNOWN_ASSET_TYPE"] = "UNKNOWN_ASSET_TYPE";
    PremiumAssetType["MAILBOX"] = "MAILBOX";
    PremiumAssetType["CATALOG_PRODUCT"] = "CATALOG_PRODUCT";
    PremiumAssetType["DIGITAL_GOOD"] = "DIGITAL_GOOD";
    PremiumAssetType["PLAN"] = "PLAN";
})(PremiumAssetType = exports.PremiumAssetType || (exports.PremiumAssetType = {}));
var RecurringType;
(function (RecurringType) {
    RecurringType["AUTO"] = "AUTO";
    RecurringType["HYBRID"] = "HYBRID";
    RecurringType["None"] = "None";
})(RecurringType = exports.RecurringType || (exports.RecurringType = {}));
var TaxIdFieldMode;
(function (TaxIdFieldMode) {
    TaxIdFieldMode["HIDE"] = "HIDE";
    TaxIdFieldMode["MANDATORY"] = "MANDATORY";
    TaxIdFieldMode["UNKNOWN"] = "UNKNOWN";
    TaxIdFieldMode["OPTIONAL"] = "OPTIONAL";
})(TaxIdFieldMode = exports.TaxIdFieldMode || (exports.TaxIdFieldMode = {}));
var TaxType;
(function (TaxType) {
    TaxType["TW_VAT"] = "TW_VAT";
    TaxType["CA_GST"] = "CA_GST";
    TaxType["REGULAR"] = "REGULAR";
    TaxType["MY_VAT"] = "MY_VAT";
    TaxType["TH_VAT"] = "TH_VAT";
    TaxType["KR_VAT"] = "KR_VAT";
    TaxType["BR_CNPJ"] = "BR_CNPJ";
    TaxType["IS_VAT"] = "IS_VAT";
    TaxType["IL_VAT"] = "IL_VAT";
    TaxType["NO_VAT"] = "NO_VAT";
    TaxType["IN_GST"] = "IN_GST";
    TaxType["AU_GST"] = "AU_GST";
    TaxType["CA_QST"] = "CA_QST";
    TaxType["AE_VAT"] = "AE_VAT";
    TaxType["KZ_VAT"] = "KZ_VAT";
    TaxType["IN_RNR"] = "IN_RNR";
    TaxType["CL_VAT"] = "CL_VAT";
    TaxType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    TaxType["NZ_GST"] = "NZ_GST";
    TaxType["SG_GST"] = "SG_GST";
    TaxType["CA_HST"] = "CA_HST";
    TaxType["TR_VAT"] = "TR_VAT";
    TaxType["GE_VAT"] = "GE_VAT";
    TaxType["EU_VAT"] = "EU_VAT";
    TaxType["RU_TIN"] = "RU_TIN";
    TaxType["JAPAN_JCT"] = "JAPAN_JCT";
    TaxType["MD_VAT"] = "MD_VAT";
    TaxType["NG_VAT"] = "NG_VAT";
    TaxType["US_TAX"] = "US_TAX";
    TaxType["UA_VAT"] = "UA_VAT";
    TaxType["CA_PST"] = "CA_PST";
})(TaxType = exports.TaxType || (exports.TaxType = {}));
var ThreeDsChallengeDisplaySizeEnum;
(function (ThreeDsChallengeDisplaySizeEnum) {
    ThreeDsChallengeDisplaySizeEnum["LARGE"] = "LARGE";
    ThreeDsChallengeDisplaySizeEnum["UNKNOWN"] = "UNKNOWN";
    ThreeDsChallengeDisplaySizeEnum["SMALL"] = "SMALL";
    ThreeDsChallengeDisplaySizeEnum["MEDIUM"] = "MEDIUM";
})(ThreeDsChallengeDisplaySizeEnum = exports.ThreeDsChallengeDisplaySizeEnum || (exports.ThreeDsChallengeDisplaySizeEnum = {}));
var ThreeDsProviderEnum;
(function (ThreeDsProviderEnum) {
    ThreeDsProviderEnum["PAYMENTS"] = "PAYMENTS";
    ThreeDsProviderEnum["ADYEN"] = "ADYEN";
    ThreeDsProviderEnum["WORLDPAY"] = "WORLDPAY";
    ThreeDsProviderEnum["UNKNOWN"] = "UNKNOWN";
})(ThreeDsProviderEnum = exports.ThreeDsProviderEnum || (exports.ThreeDsProviderEnum = {}));
//# sourceMappingURL=types.js.map